import { render, staticRenderFns } from "./ModalExamEditor.vue?vue&type=template&id=5be83962"
import script from "./ModalExamEditor.vue?vue&type=script&lang=js"
export * from "./ModalExamEditor.vue?vue&type=script&lang=js"
import style0 from "./ModalExamEditor.vue?vue&type=style&index=0&id=5be83962&prod&lang=css&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports